import { getProfile } from "../api/profile";
import { queryKeys } from "../constants/constans";
import { useQuery } from "react-query";

export default function useProfile(enabled = false) {
  const { data: profile, refetch: refetchProfile } = useQuery<any>(
    queryKeys.profile,
    getProfile,
    { enabled }
  );
  return { profile, refetchProfile };
}
